import { render } from "./IconTextButton.vue?vue&type=template&id=4917c168&scoped=true"
import script from "./IconTextButton.vue?vue&type=script&lang=js"
export * from "./IconTextButton.vue?vue&type=script&lang=js"

import "./IconTextButton.vue?vue&type=style&index=0&id=4917c168&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4917c168"]])

export default __exports__